// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductDetailViewNew/style.css
// module id = 2035
// module chunks = 0